export const initialStream = {
  name: '',
  description: '',
  id: '',
  properties: {},
  topics: [],
  locations: [],
  channels: [],
  metadata: {
    createdBy: '',
    createdAt: '',
    private: true,
    coverPicUrl: '',
    profilePicUrl: '',
  },
  userData: {
    streamCID: {
      orgId: '',
      streamId: '',
    },
    userChannels: [],
    userRoleMapping: {
      userId: '',
      roles: [],
      mapping: [],
    },
    hasBookmarked: false,
  },
};
